export default __webpack_public_path__ + "static/media/construction-bar.1ece700a.svg";